import React, { Component } from 'react';
import HumidityLevelView from './HumidityLevelView';
import { connect } from 'react-redux';
import * as tripActions from '../../../actions/tripActions';

class HumidityLevelContainer extends Component {
  changeStep = (step, values) => {
    const { changeCurrentStep, saveTripData } = this.props;
    changeCurrentStep(step);
    saveTripData(values);
  };

  render() {
    return <HumidityLevelView {...this.props} changeStep={this.changeStep} state={this.state} />;
  }
}

function mapStateToProps(state) {
  return {
    humidity_levels: state.tripReducer.tripForm.humidity_levels,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeCurrentStep: step => dispatch(tripActions.changeCurrentStep(step)),
    saveTripData: data => dispatch(tripActions.saveTripData(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HumidityLevelContainer);
